// extracted by mini-css-extract-plugin
module.exports = {"Gallery":"Gallery_Gallery__2ebOR"};